/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";

/** @module core/modules/number-utils/get-arithmetic-mean */

/**
 * @description Calculates the arithmetic mean of the input numbers array.
 * @param {Array<number>} input - Input numbers array.
 * @param {Array<number>} [weights] - Corresponding weights array.
 * @returns {null|number} Calculated arithmetic mean.
 */
function getArithmeticMean(input, weights) {
  var _this = this,
      _context;

  var totalWeight = weights && _reduceInstanceProperty(weights).call(weights, _bindInstanceProperty(_context = function _context(a, b) {
    _newArrowCheck(this, _this);

    return a + b;
  }).call(_context, this), 0);

  var result = 0;

  if (weights) {
    var _context2;

    if (input.length !== weights.length) {
      return null;
    }

    _forEachInstanceProperty(input).call(input, _bindInstanceProperty(_context2 = function _context2(val, index) {
      _newArrowCheck(this, _this);

      result += val * weights[index] / totalWeight;
    }).call(_context2, this));
  } else {
    var _context3;

    _forEachInstanceProperty(input).call(input, _bindInstanceProperty(_context3 = function _context3(val, index) {
      _newArrowCheck(this, _this);

      result = (result * index + val) / (index + 1);
    }).call(_context3, this));
  }

  return result;
}

export { getArithmeticMean };